import "./Interests.scss";
import { useTranslation } from 'react-i18next';
import Card from "../Card/Card";

const Interests = ()=> {
    const { t } = useTranslation();
    const interestsData = t("interestsData", { returnObjects: true });
    return (
      <section id="interests" className="interests">
        <h2 className="interests__title">
          {t("interestsTitle1")}
          <span className="interests__title--special">
            {t("interestsTitle2")}
          </span>
        </h2>
        <div className="interests__container">
          {interestsData.map((card, idx) => (
            <Card
              key={idx}
              image={card.image}
              title={card.title}
              content={card.content}
            />
          ))}
        </div>
      </section>
    );
}

export default Interests;